import React, { useState } from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MenuItemType } from 'utility/enumerations';
import { v4 as uuid } from 'uuid';
// @ts-ignore
import styles from './site.module.scss';
import { globalEndpoints } from '../../../endpoints/global';

interface MainMenuProps {
  menuItems: any,
  history: any
}

export const MainMenu = (props: MainMenuProps) => {
  const [expanded, setExpanded] = useState(false);
  const handleSelect = (event) => {
    if (event.item && event.item.type === MenuItemType.Navigation && event.item.route) {
      props.history.push(event.item.route);
    }
    setExpanded(false);
  };
  return (
    <div className="main-menu">
      <Navbar expanded={expanded} collapseOnSelect onSelect={handleSelect} bg="light" expand="lg" aria-labelledby="basic-navbar-nav">
        <Navbar.Toggle
          onClick={() => setExpanded(!expanded)}
          aria-controls="responsive-navbar-nav"
          onBlur={() => setExpanded(false)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            {props.menuItems.map((menuItem) => {
              if (menuItem.children !== undefined && menuItem.children.length) {
                return (
                  <NavDropdown
                    title={menuItem.text}
                    className={styles.navMenu}
                    key={uuid()}
                    id={uuid()}
                  >
                    {menuItem.children.map((child) => {
                      if (child.childMenuNavigationDtos !== undefined && child.childMenuNavigationDtos.length) {
                        return (
                          <NavDropdown
                            title={child.text}
                            className={styles.navMenu}
                            key={uuid()}
                            id={child.route}
                            drop="end"
                          >
                            {child.childMenuNavigationDtos.map((grandchild) => {
                              return (
                                <Nav.Link
                                  as={Link}
                                  to={{ pathname: grandchild.route, fromNavigation: true }}
                                  className={styles.navMenu}
                                  key={uuid()}
                                  id={grandchild.route}
                                >
                                  {grandchild.text}
                                </Nav.Link>
                              );
                            })}
                          </NavDropdown>
                        );
                      }
                      return (
                        <Nav.Link
                          as={Link}
                          to={{ pathname: child.route, fromNavigation: true }}
                          className={styles.navMenu}
                          key={uuid()}
                          id={child.route}
                        >
                          {child.text}
                        </Nav.Link>
                      );
                    })}
                  </NavDropdown>
                );
              }
              if (menuItem.route.startsWith('api/')) {
                return (
                  <Nav.Link
                    as="a"
                    href={`${globalEndpoints.apiUrl}${menuItem.route.replace('api', '')}`}
                    className={styles.navMenu}
                    key={uuid()}
                    id={menuItem.route}
                  >
                    {menuItem.text}
                  </Nav.Link>
                );
              }
              return (
                <Nav.Link
                  as={Link}
                  to={{ pathname: menuItem.route, fromNavigation: true }}
                  className={styles.navMenu}
                  key={uuid()}
                  id={menuItem.route}
                >
                  {menuItem.text}
                </Nav.Link>
              );
            })}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
